import { render, staticRenderFns } from "./FirstAidVideo_details.vue?vue&type=template&id=55335e66&"
import script from "./FirstAidVideo_details.vue?vue&type=script&lang=js&"
export * from "./FirstAidVideo_details.vue?vue&type=script&lang=js&"
import style0 from "./FirstAidVideo_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports